import React, { useState } from "react";
import TopBar from "@/components/TopBar";
import PhaseProgress from "@/components/PhaseProgress";
import Phase1TrailerConfig from "@/components/wizard/Phase1TrailerConfig";
import Phase2CustomerCosts from "@/components/wizard/Phase2CustomerCosts";
import Phase3PrimoCosts from "@/components/wizard/Phase3PrimoCosts";
import Phase4Comparison from "@/components/wizard/Phase4Comparison";
import Phase5Reveal from "@/components/wizard/Phase5Reveal";
import PresentationOverlay from "@/components/PresentationOverlay";
import { useSimulation } from "@/context/SimulationContext";
import { Maximize2 } from "lucide-react";

export default function SimulatorPage() {
  const { phase } = useSimulation();
  const [showPresentation, setShowPresentation] = useState(false);

  return (
    <div className="min-h-screen">
      <TopBar />
      <PhaseProgress />
      {phase === 1 && <Phase1TrailerConfig />}
      {phase === 2 && <Phase2CustomerCosts />}
      {phase === 3 && <Phase3PrimoCosts />}
      {phase === 4 && <Phase4Comparison />}
      {phase === 5 && <Phase5Reveal />}

      {/* Floating presentation mode button — visible on all phases */}
      <button
        onClick={() => setShowPresentation(true)}
        data-testid="global-presentation-btn"
        className="fixed bottom-6 right-6 z-40 flex items-center gap-2 bg-[#0a0f1a] hover:bg-[#141b2d] text-white px-4 py-2.5 rounded-full shadow-xl border border-white/10 transition-all hover:scale-105 no-print"
        title="Modo Apresentação"
      >
        <Maximize2 className="w-4 h-4" />
        <span className="text-xs font-mono uppercase tracking-widest hidden sm:inline">Apresentação</span>
      </button>

      {/* Global presentation overlay */}
      {showPresentation && (
        <PresentationOverlay onClose={() => setShowPresentation(false)} />
      )}
    </div>
  );
}
